import { render } from "./barchart_component.vue?vue&type=template&id=660e8de2&ts=true"
import script from "./barchart_component.vue?vue&type=script&lang=ts"
export * from "./barchart_component.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__